import {
  Avatar,
  Badge,
  Button,
  Flex,
  Td,
  Text,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import moment from "moment";
import { useLocalStorage } from "../../useLocalStorage";
import { upperCase, upperFirst } from "lodash";
function TablesTableRow(props) {
  const [auth, setAuth] = useLocalStorage("auth_v2", null);
  const isSuperAdmin = auth?.roles?.superAdmin;
  const {
    logo,
    name,
    email,
    subdomain,
    domain,
    status,
    date,
    row,
    agentInfo,
  } = props;
  const textColor = useColorModeValue("gray.700", "white");
  const bgStatus = useColorModeValue("gray.400", "#1a202c");
  const colorStatus = useColorModeValue("white", "gray.400");
  console.log({ row });
  const nav = (
    <a href={"/viewsms/" + row.phone}>
      <Button p="0px" bg="transparent" variant="no-hover">
        <Text fontSize="md" color="gray.400" fontWeight="bold" cursor="pointer">
          View Details
        </Text>
      </Button>
    </a>
  );
  return (
    <Tr>
      <Td minWidth={{ sm: "250px" }} pl="0px">
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <Flex direction="column">
            <Text
              fontSize="md"
              color={textColor}
              fontWeight="bold"
              minWidth="100%"
            >
              {row.phone}
            </Text>

            <Text
              display={{ sm: "block", md: "none" }}
              fontSize="sm"
              color="gray.400"
              fontWeight="normal"
            >
              {row.message}
            </Text>
            <Text
              display={{ sm: "block", md: "none" }}
              fontSize="sm"
              color="gray.400"
              fontWeight="normal"
            >
              {moment(row.date).format("lll")}
            </Text>
            <Text
              display={{ sm: "block", md: "none" }}
              fontSize="sm"
              color="gray.400"
              fontWeight="normal"
            >
              {nav}
            </Text>
          </Flex>
        </Flex>
      </Td>
      <Td
        display={{ sm: "none", md: "table-cell" }}
        fontSize="sm"
        color="gray.400"
        fontWeight="normal"
      >
        {row.message}
      </Td>
      <Td display={{ sm: "none", md: "table-cell" }}>
        <Badge
          bg={status === "Online" ? "green.400" : bgStatus}
          color={status === "Online" ? "white" : colorStatus}
          fontSize="16px"
          p="3px 10px"
          borderRadius="8px"
        >
          {moment(row.date).format("lll")}
        </Badge>
      </Td>

      <Td display={"table-cell"}>{nav}</Td>
    </Tr>
  );
}

export default TablesTableRow;
